/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_TitleInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_2_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A five-cell formula check`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_2_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用五个单元格检查公式`)
};

/**
* | output |
* | --- |
* | "A five-cell formula check" |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_2_title = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_2_title(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_2_title(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_2_title as "gc.search_guides.gridcraft_excel_compatibility.sections.2.title" }